export default "__VITE_ASSET__90eff4fd__"